// extracted by mini-css-extract-plugin
export default {"search-input__container":"R8atWStkgjFjc6RVlhwV"};